﻿<template>

    <header class=" px-6 pb-6 header">
        <header_menu></header_menu>
        <h1>My Profile</h1>
        <div class="grid grid-cols-1 md:grid-cols-2">
            <div class="col-span-1 md:col-span-2 p-2 my-2 border-2 rounded border-grey-default">
                <consultant_information :selected_contact="Get_Contact()"></consultant_information>
            </div>
            <div class="border-2 p-2 my-2 rounded border-grey-default md:mr-2">
                <account_information></account_information>
            </div>
            <div class="border-2 p-2 my-2 rounded border-grey-default">
                <change_account_password></change_account_password>
            </div>
        </div>
    </header>

</template>

<script lang="ts" src="./my_profile.ts"></script>